export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP'

export const updateStep = activeStep => ({
	type: SET_ACTIVE_STEP,
	payload: activeStep
})

export default function setActiveStep(activeRoom) {
	return dispatch => {
		dispatch(updateStep(activeRoom))
	}
}



// WEBPACK FOOTER //
// ./src/actions/activeStepActions.js